import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromServiceItem from '.';
import { processResolver } from '../efaact-routing/process-resolver';

const log = new LoggingService();

export const ServiceItemRoute: Ng2StateDeclaration = {
    // name: 'ServiceItem.**'
    name: 'serviceitemsetting',
    url: '/serviceitemsetting',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.ServiceItemModule)
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromServiceItem.ServiceItemContainerComponent
};
